import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

import { BidNotificationInfo, BmDataAccessFacade } from '@nexweb/shared/data-access/bm';

import { RequestExtensionOfActivationPeriod } from '../../../models';
import { RequestExtensionOfActivationPeriodService } from '../../../services';
import { ExtensionFormComponent } from '../extension-form/extension-form.component';

@Component({
  selector: 'nexweb-ext-req-tso-conf',
  templateUrl: './ext-req-tso-conf.component.html',
  imports: [AsyncPipe, ExtensionFormComponent],
})
export class ExtReqTsoConfComponent implements OnInit {
  @Input() bidId: number;

  public extension$: Observable<RequestExtensionOfActivationPeriod.ActivationExtension>;
  public dateTimeFormat: string;
  public labels: RequestExtensionOfActivationPeriod.Labels;
  public headings: RequestExtensionOfActivationPeriod.Headings;

  private bmFacade = inject(BmDataAccessFacade);
  private requestExtensionOfActivationService = inject(RequestExtensionOfActivationPeriodService);

  ngOnInit(): void {
    this.labels = this.requestExtensionOfActivationService.getConfirmationLabels();
    this.headings = this.requestExtensionOfActivationService.getConfirmationHeadings();
    this.dateTimeFormat = this.requestExtensionOfActivationService.getDateTimeFormat();

    this.initialiseData();
  }

  private initialiseData(): void {
    this.extension$ = this.bmFacade.getBidNotificationInfo(this.bidId).pipe(
      map((bidNotificationInfo: BidNotificationInfo) => {
        const bidNotificationData = {
          name: bidNotificationInfo.supplyingTsoName,
          telephoneNumber: bidNotificationInfo.supplyingTsoPhoneNumber,
          portfolio: bidNotificationInfo.supplyingBspPortfolioName,
          requestedQuantity: bidNotificationInfo.requestedQuantity,
          instrument: bidNotificationInfo.instrument,
          requestedActivationTime: bidNotificationInfo.requestFullDispatchTime,
        } as RequestExtensionOfActivationPeriod.ActivationExtension;

        return bidNotificationData;
      }),
    );
  }
}
